import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { PermissionService } from './permission.service';
import { RouteTenantScope } from '../company/tenant-access.model';

@Injectable({
    providedIn: 'root'
})
export class PermissionGuard implements CanActivate, CanActivateChild {

    constructor(
        private permissionService: PermissionService,
        private router: Router,
        private messageService: MessageService
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.checkPermission(route);
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.checkPermission(childRoute);
    }

    private checkPermission(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const requiredPermission = route.data['permission'];
        const requiredScope = route.data['scope'] as RouteTenantScope | undefined;

        if (!requiredPermission) {
            return true;
        }

        const hasPermission = Array.isArray(requiredPermission)
            ? this.permissionService.hasAnyPermission(requiredPermission, requiredScope)
            : this.permissionService.hasPermission(requiredPermission, requiredScope);

        const groupPermission = route.data['groupPermission'] as string | undefined;
        if (hasPermission || (groupPermission && this.permissionService.hasAccessibleGroupPermission(groupPermission))) {
            return true;
        }

        this.messageService.add({
            severity: 'error',
            summary: 'Unauthorized',
            detail: 'You do not have permission to access this page.'
        });
        return this.router.createUrlTree(['/dashboard']);
    }
}
